/* SB CT Cart — slider, countdown, cart qty controls */
(function(){'use strict';
if(window.__SBCC_BOOTED__)return;
window.__SBCC_BOOTED__=true;

function initCountdown(root){
  var defaultSec=parseInt(root.dataset.cdDefault,10)||7200;
  var key=root.dataset.cdKey||'sbcc_cd_end';
  var stored=sessionStorage.getItem(key);
  var endMs=stored?parseInt(stored,10):null;
  if(!endMs||endMs<=Date.now()){
    endMs=Date.now()+defaultSec*1000;
    sessionStorage.setItem(key,String(endMs));
  }
  var elH=root.querySelector('[data-cd="hours"]'),elM=root.querySelector('[data-cd="minutes"]'),elS=root.querySelector('[data-cd="seconds"]');
  if(!elH||!elM||!elS)return;
  function tick(){
    var diff=endMs-Date.now();
    if(diff<=0){endMs=Date.now()+defaultSec*1000;sessionStorage.setItem(key,String(endMs));diff=endMs-Date.now()}
    var sec=Math.floor(diff/1000),h=Math.floor(sec/3600),m=Math.floor((sec%3600)/60),s=sec%60;
    elH.textContent=String(h).padStart(2,'0');
    elM.textContent=String(m).padStart(2,'0');
    elS.textContent=String(s).padStart(2,'0');
  }
  tick();setInterval(tick,1000);
}

function findSliderFor(el){
  var section=el.closest('.shopify-section')||el.closest('section.sbcc-gallery')||el.closest('section')||document;
  return section.querySelector('[data-sbcc-slider]');
}
function scrollSliderTo(slider,idx){
  if(!slider)return;
  var track=slider.querySelector('[data-sbcc-track]');
  if(!track)return;
  var w=track.clientWidth;
  var max=track.children.length-1;
  if(idx<0)idx=0;
  if(idx>max)idx=max;
  track.scrollTo({left:w*idx,behavior:'smooth'});
}
function currentSliderIndex(slider){
  var track=slider.querySelector('[data-sbcc-track]');
  if(!track)return 0;
  var w=track.clientWidth;
  if(w===0)return 0;
  return Math.round(track.scrollLeft/w);
}
function initSlider(root){
  if(root.dataset.sbccInited==='1')return;
  root.dataset.sbccInited='1';
  var track=root.querySelector('[data-sbcc-track]');
  var dotsWrap=root.querySelector('[data-sbcc-dots]');
  var prev=root.querySelector('[data-sbcc-prev]');
  var next=root.querySelector('[data-sbcc-next]');
  if(!track){if(prev)prev.style.display='none';if(next)next.style.display='none';return;}
  var slides=track.children;
  if(slides.length<=1){
    if(prev)prev.style.display='none';
    if(next)next.style.display='none';
    if(dotsWrap)dotsWrap.style.display='none';
    var section1=root.closest('.shopify-section')||root.closest('section');
    var tw1=section1?section1.querySelector('[data-sbcc-thumbs]'):null;
    if(tw1&&tw1.querySelectorAll('[data-sbcc-thumb-idx]').length<=1)tw1.style.display='none';
    return;
  }
  var section=root.closest('.shopify-section')||root.closest('section');
  var thumbsWrap=section?section.querySelector('[data-sbcc-thumbs]'):null;
  var thumbs=thumbsWrap?thumbsWrap.querySelectorAll('[data-sbcc-thumb-idx]'):[];
  var dots=[];
  if(dotsWrap){
    dotsWrap.innerHTML='';
    for(var i=0;i<slides.length;i++){
      (function(idx){
        var d=document.createElement('button');
        d.type='button';
        d.className='sbcc-slider__dot'+(idx===0?' is-active':'');
        d.setAttribute('aria-label','Slide '+(idx+1));
        d.dataset.sbccDotIdx=String(idx);
        dotsWrap.appendChild(d);
        dots.push(d);
      })(i);
    }
  }
  function updateActive(){
    var idx=currentSliderIndex(root);
    for(var i=0;i<dots.length;i++)dots[i].classList.toggle('is-active',i===idx);
    for(var j=0;j<thumbs.length;j++)thumbs[j].classList.toggle('is-active',j===idx);
  }
  var raf=null;
  track.addEventListener('scroll',function(){
    if(raf)cancelAnimationFrame(raf);
    raf=requestAnimationFrame(updateActive);
  },{passive:true});
}

/* Global event delegation — bulletproof against script-load timing */
document.addEventListener('click',function(e){
  var t=e.target;
  var hit;
  if((hit=t.closest('[data-sbcc-prev]'))){
    var s=findSliderFor(hit);
    if(s){e.preventDefault();scrollSliderTo(s,currentSliderIndex(s)-1);}
    return;
  }
  if((hit=t.closest('[data-sbcc-next]'))){
    var s=findSliderFor(hit);
    if(s){e.preventDefault();scrollSliderTo(s,currentSliderIndex(s)+1);}
    return;
  }
  if((hit=t.closest('[data-sbcc-thumb-idx]'))){
    var s=findSliderFor(hit);
    if(s){e.preventDefault();scrollSliderTo(s,parseInt(hit.dataset.sbccThumbIdx,10)||0);}
    return;
  }
  if((hit=t.closest('[data-sbcc-dot-idx]'))){
    var s=findSliderFor(hit);
    if(s){e.preventDefault();scrollSliderTo(s,parseInt(hit.dataset.sbccDotIdx,10)||0);}
    return;
  }
});

function changeQty(line,qty){
  var summary=document.querySelector('[data-sbcc-summary]');
  if(summary)summary.classList.add('sbcc-loading');
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({line:line,quantity:qty})
  }).then(function(r){return r.json();}).then(function(){
    window.location.reload();
  }).catch(function(){
    if(summary)summary.classList.remove('sbcc-loading');
  });
}

function initCartItems(){
  document.querySelectorAll('[data-sbcc-qty-inc]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var line=parseInt(btn.dataset.sbccQtyInc,10);
      var current=parseInt(btn.dataset.sbccQtyCurrent,10)||1;
      changeQty(line,current+1);
    });
  });
  document.querySelectorAll('[data-sbcc-qty-dec]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var line=parseInt(btn.dataset.sbccQtyDec,10);
      var current=parseInt(btn.dataset.sbccQtyCurrent,10)||1;
      if(current<=1){changeQty(line,0);return;}
      changeQty(line,current-1);
    });
  });
  document.querySelectorAll('[data-sbcc-remove]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var line=parseInt(btn.dataset.sbccRemove,10);
      changeQty(line,0);
    });
  });
}

function initCheckout(){
  var btn=document.querySelector('[data-sbcc-checkout]');
  if(!btn)return;
  btn.addEventListener('click',function(e){
    e.preventDefault();
    var code=btn.dataset.sbccDiscount||'';
    if(code){
      window.location.href='/discount/'+encodeURIComponent(code)+'?redirect=%2Fcheckout';
    }else{
      window.location.href='/checkout';
    }
  });
}

function boot(){
  document.querySelectorAll('[data-sbcc-countdown]').forEach(initCountdown);
  document.querySelectorAll('[data-sbcc-slider]').forEach(initSlider);
  initCartItems();
  initCheckout();
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',boot);
}else{
  boot();
}
})();
